export const DragTypes = {
  tile: "tile",
};
